<template>
  <div class="container">
    <loading v-bind:active.sync="loading"></loading>
    <auth-modal ref="authModal"></auth-modal>
    <div class="row top-padding">
      <div class="col-lg-3 offset-lg-2">
        <label for="code">Code (Give to clients)<span class="red">*</span></label>
      </div>
      <div class="col-lg-5">
        <input type="text" v-model="code" class="form-control">
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="licenseNumber">License #<span class="red">*</span></label>
      </div>
      <div class="col-lg-5">
        <input type="text" v-model="licenseNumber" class="form-control">
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="name">Your Name<span class="red">*</span></label>
      </div>
      <div class="col-lg-5">
        <input type="text" v-model="name" class="form-control">
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="brokerageName">Brokerage Name<span class="red">*</span></label>
      </div>
      <div class="col-lg-5">
        <input type="text" v-model="brokerageName" class="form-control">
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="backgroundColorValue">Brokerage Color<span class="red">*</span></label>
      </div>
      <div class="col-lg-5">
        <div class="input-group" ref="backgroundColorPicker">
          <input type="text" v-model="backgroundColorValue" v-on:focus="showBackgroundColorPicker()" v-on:input="updateBackgroundColorFromInput" class="form-control">
          <div class="input-group-append">
            <div class="input-group-text pointer-cursor" v-on:click="toggleBackgroundColorPicker()">
              <div class="current-color" v-bind:style="'background-color: ' + backgroundColorValue"></div>
            </div>
            <color-picker v-if="displayBackgroundColorPicker" v-bind:value="backgroundColors" v-bind:disableAlpha="true" v-on:input="updateBackgroundColorFromPicker" class="color-picker"></color-picker>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="textColorValue">Text Color</label><span class="red">*</span>
      </div>
      <div class="col-lg-5">
        <div class="input-group" ref="textColorPicker">
          <input type="text" v-model="textColorValue" v-on:focus="showTextColorPicker()" v-on:input="updateTextColorFromInput" class="form-control">
          <div class="input-group-append">
            <div class="input-group-text pointer-cursor" v-on:click="toggleTextColorPicker()">
              <div class="current-color" v-bind:style="'background-color: ' + textColorValue"></div>
            </div>
            <color-picker v-if="displayTextColorPicker" v-bind:value="textColors" v-bind:disableAlpha="true" v-on:input="updateTextColorFromPicker" class="color-picker"></color-picker>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="phoneNumber">Customer Contact Phone Number<span class="red">*</span></label>
      </div>
      <div class="col-lg-5">
        <input type="text" v-model="phoneNumber" class="form-control">
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="email">Customer Contact Email Address<span class="red">*</span></label>
      </div>
      <div class="col-lg-5">
        <input type="text" v-model="email" class="form-control">
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="profilePicture">Profile Picture</label><span class="red">*</span>
      </div>
      <div class="col-lg-5 fix-custom-label">
        <label class="custom-file-label" for="customFile">Upload file</label>
        <input class="custom-file-input" id="customFile" type="file" accept="image/png, image/jpeg" v-on:change="previewImage">
        <img class="preview-image" v-bind:src="profilePicture" v-on:click="updateProfilePicture(null)" height="100px">
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="brokeragePicture">Brokerage Picture</label><span class="red">*</span>
      </div>
      <div class="col-lg-5 fix-custom-label">
        <label class="custom-file-label" for="customFile2">Upload file</label>
        <input class="custom-file-input" id="customFile2" type="file" accept="image/png, image/jpeg" v-on:change="previewImage2">
        <img class="preview-image" v-bind:src="brokeragePicture" v-on:click="updateBrokeragePicture(null)" height="100px">
      </div>
    </div>
    <div class="row">
      <div class="col-4 offset-4">
        <button class="btn btn-primary" v-on:click="createRealtor()">Register</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Chrome } from 'vue-color'
import AuthModal from '../authentication/TheAuthModal.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import router from '../../router/index.js'

export default {
  components: {
    AuthModal,
    'color-picker': Chrome,
    Loading
  },
  data () {
    return {
      backgroundColors: {
        hex: '#000000'
      },
      code: null,
      displayBackgroundColorPicker: false,
      displayTextColorPicker: false,
      textColors: {
        hex: '#000000'
      },
      loading: false
    }
  },
  methods: {
    ...mapActions('business', [
      'getUserAttributes'
    ]),
    ...mapActions('realtor', [
      'putRealtorData'
    ]),
    ...mapMutations('realtor', [
      'updateBrokerageName',
      'updateBrokeragePicture',
      'updateLicenseNumber',
      'updatePhoneNumber',
      'updateProfilePicture',
      'updateRealtorBackgroundColor',
      'updateRealtorCode',
      'updateRealtorCognitoId',
      'updateRealtorEmail',
      'updateRealtorName',
      'updateRealtorTextColor'
    ]),
    previewImage: function (event) {
      var input = event.target
      var that = this
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = function (e) {
          if (!that.profilePicture || (that.profilePicture && !that.profilePicture.includes(e.target.result))) {
            var img = new Image()
            img.onload = function () {
              if (this.width > 150 && this.height > 150) {
                that.updateProfilePicture(e.target.result)
              } else {
                that.imageTooSmall = true
              }
            }
          }
          img.src = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }

      var fileInput = document.getElementById('customFile')
      fileInput.value = null
    },
    previewImage2: function (event) {
      var input = event.target
      var that = this
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = function (e) {
          if (!that.brokeragePicture || (that.brokeragePicture && !that.brokeragePicture.includes(e.target.result))) {
            var img = new Image()
            img.onload = function () {
              if (this.width > 150 && this.height > 150) {
                that.updateBrokeragePicture(e.target.result)
              } else {
                that.imageTooSmall = true
              }
            }
          }
          img.src = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }

      var fileInput = document.getElementById('customFile2')
      fileInput.value = null
    },
    updateBackgroundColorFromInput (picker) {
      this.updateBackgroundColors(this.backgroundColorValue)
    },
    updateTextColorFromInput (picker) {
      this.updateTextColors(this.textColorValue)
    },
    updateBackgroundColorFromPicker (color) {
      this.backgroundColors = color
      if (color.rgba.a === 1) {
        this.backgroundColorValue = color.hex
      } else {
        this.backgroundColorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')'
      }
    },
    updateTextColorFromPicker (color) {
      this.textColors = color
      if (color.rgba.a === 1) {
        this.textColorValue = color.hex
      } else {
        this.textColorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')'
      }
    },
    updateBackgroundColors (color) {
      if (color.slice(0, 1) === '#') {
        this.backgroundColors = {
          hex: color
        }
      } else if (color.slice(0, 4) === 'rgba') {
        var rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',')
        var hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1)
        this.backgroundColors = {
          hex: hex,
          a: rgba[3]
        }
      }
    },
    updateTextColors (color) {
      if (color.slice(0, 1) === '#') {
        this.textColors = {
          hex: color
        }
      } else if (color.slice(0, 4) === 'rgba') {
        var rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',')
        var hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1)
        this.textColors = {
          hex: hex,
          a: rgba[3]
        }
      }
    },
    hideBackgroundColorPicker () {
      document.removeEventListener('click', this.documentClickForBackgroundColorPicker)
      this.displayBackgroundColorPicker = false
    },
    hideTextColorPicker () {
      document.removeEventListener('click', this.documentClickForTextColorPicker)
      this.displayTextColorPicker = false
    },
    showBackgroundColorPicker () {
      document.addEventListener('click', this.documentClickForBackgroundColorPicker)
      this.displayBackgroundColorPicker = true
    },
    showTextColorPicker () {
      document.addEventListener('click', this.documentClickForTextColorPicker)
      this.displayTextColorPicker = true
    },
    toggleBackgroundColorPicker () {
      this.displayBackgroundColorPicker ? this.hideBackgroundColorPicker() : this.showBackgroundColorPicker()
    },
    toggleTextColorPicker () {
      this.displayTextColorPicker ? this.hideTextColorPicker() : this.showTextColorPicker()
    },
    documentClickForBackgroundColorPicker (e) {
      var el = this.$refs.backgroundColorPicker
      var target = e.target
      if (el !== target && !el.contains(target)) {
        this.hideBackgroundColorPicker()
      }
    },
    documentClickForTextColorPicker (e) {
      var el = this.$refs.textColorPicker
      var target = e.target
      if (el !== target && !el.contains(target)) {
        this.hideTextColorPicker()
      }
    },
    async createRealtor () {
      if (!this.getIdProvider) {
        this.$global.gaEvent('realtorLoginPrompted', 'navigation', 'User prompted to sign up from realtor registration page')
        this.$refs.authModal.$refs.authModal.show()
        return
      }
      this.$global.gaEvent('realtorRegistration', 'backendCall')
      this.loading = true
      try {
        this.updateRealtorCognitoId(this.getCognitoId)
        await this.putRealtorData({ code: this.code, method: 'POST' })
        this.updateRealtorCode(this.code)
        this.getUserAttributes()
        router.push('/profile/realtor/dashboard')
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    }
  },
  computed: {
    ...mapGetters([
      'getCognitoId',
      'getIdProvider'
    ]),
    ...mapGetters('realtor', [
      'getBrokerageName',
      'getBrokeragePicture',
      'getLicenseNumber',
      'getPhoneNumber',
      'getProfilePicture',
      'getRealtorBackgroundColor',
      'getRealtorEmail',
      'getRealtorName',
      'getRealtorTextColor'
    ]),
    backgroundColorValue: {
      get () {
        return this.getRealtorBackgroundColor
      },
      set (value) {
        this.updateRealtorBackgroundColor(value)
      }
    },
    brokerageName: {
      get () {
        return this.getBrokerageName
      },
      set (value) {
        this.updateBrokerageName(value)
      }
    },
    brokeragePicture: {
      get () {
        return this.getBrokeragePicture
      },
      set (value) {
        this.updateBrokeragePicture(value)
      }
    },
    licenseNumber: {
      get () {
        return this.getLicenseNumber
      },
      set (value) {
        this.updateLicenseNumber(value)
      }
    },
    email: {
      get () {
        return this.getRealtorEmail
      },
      set (value) {
        this.updateRealtorEmail(value)
      }
    },
    name: {
      get () {
        return this.getRealtorName
      },
      set (value) {
        this.updateRealtorName(value)
      }
    },
    phoneNumber: {
      get () {
        return this.getPhoneNumber
      },
      set (value) {
        this.updatePhoneNumber(value)
      }
    },
    profilePicture: {
      get () {
        return this.getProfilePicture
      },
      set (value) {
        this.updateProfilePicture(value)
      }
    },
    realtorName: {
      get () {
        return this.getRealtorName
      },
      set (value) {
        this.updateRealtorName(value)
      }
    },
    textColorValue: {
      get () {
        return this.getRealtorTextColor
      },
      set (value) {
        this.updateRealtorTextColor(value)
      }
    }
  },
  mounted () {
    this.$global.gaEvent('realtorViewRegistration', 'navigation')
  }
}
</script>

<style scoped>
.custom-file-input {
  line-height: 1.25;
}

.custom-file-label {
  line-height: 1.25;
}

@media (min-width: 992px) {
  .custom-file-label {
    width: 368px;
  }
}

@media (min-width: 1200px) {
  .custom-file-label {
    width: 443px;
  }
}

@media (min-width: 1500px) {
  .custom-file-label {
    width: 551.328px;
  }
}

.custom-file-label::after {
  line-height: 1.25;
}

.fix-custom-label {
  padding: 0;
  margin: 0 15px;
}

.row {
  margin-bottom: 1.5rem;
}

.color-picker {
  position: absolute;
  top: 39px;
  right: 15px;
  z-index: 3;
}

.current-color {
  display: inline-block;
  width: 16px;
  height: 16px;
}

label {
  font-size: 1.25rem;
  margin: 0;
}

.top-padding {
  padding-top: 3rem;
}

.pointer-cursor {
  cursor: pointer;
}

.red {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/realty/RealtorSignUp.vue